export const GOOGLE_LOGIN = 'GOOGLE_LOGIN';
export const GOOGLE_LOGOUT = 'GOOGLE_LOGOUT';